import angular from 'angular';
import { ProductCommissionModule } from './commission/product-commission.module';
import { EditProductLineComponent } from './product-lines/edit-product-line.component';
import { ProductLinesListComponent } from './product-lines/product-lines-list.component';
import { ProductsListComponent } from './products/products-list.component';
import { EditProductComponent } from './products/edit-product.component';
export const ProductModule = angular
    .module("apex.mainApp.product", [
        ProductCommissionModule
    ])
    .component("apexProductLinesList", ProductLinesListComponent)
    .component("apexEditProductLine", EditProductLineComponent)
    .component("apexProductsList", ProductsListComponent)
    .component("apexEditProduct", EditProductComponent)
    .name;
